import { render, staticRenderFns } from "./RequestTableItem.vue?vue&type=template&id=47ab765f&"
import script from "./RequestTableItem.vue?vue&type=script&lang=js&"
export * from "./RequestTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequestTableItem.vue"
export default component.exports